import axios from 'axios'
import { apiHeader, SERVER_URL } from '../config'
import { Faq } from '../types/faq.type'

// Alias pour la compatibilité avec le code existant
export type FaqItem = Faq

// Fonctions d'API pour les FAQ
export const apiGetFaqs = async (category?: string, activeOnly: boolean = true): Promise<Faq[]> => {
    const tokenAdmin = localStorage.getItem('tokenAdmin')
    const params = new URLSearchParams()
    
    if (category) params.append('category', category)
    if (activeOnly) params.append('activeOnly', 'true')
    
    const queryString = params.toString()
    const url = queryString ? `${SERVER_URL}/faq?${queryString}` : `${SERVER_URL}/faq`
    const response = await axios.get<Faq[]>(url, tokenAdmin ? apiHeader(tokenAdmin) : undefined)
    return response.data
}

export const apiGetFaq = async (id: string): Promise<Faq> => {
    const tokenAdmin = localStorage.getItem('tokenAdmin')
    const response = await axios.get<Faq>(`${SERVER_URL}/faq/${id}`, tokenAdmin ? apiHeader(tokenAdmin) : undefined)
    return response.data
}

export const apiCreateFaq = async (data: Omit<Faq, 'id' | 'createdAt' | 'updatedAt'>): Promise<Faq> => {
    const tokenAdmin = localStorage.getItem('tokenAdmin')
    if (!tokenAdmin) throw new Error('Non autorisé')
    const response = await axios.post<Faq>(`${SERVER_URL}/faq`, data, apiHeader(tokenAdmin))
    return response.data
}

export const apiUpdateFaq = async (id: string, data: Partial<Faq>): Promise<Faq> => {
    const tokenAdmin = localStorage.getItem('tokenAdmin')
    if (!tokenAdmin) throw new Error('Non autorisé')
    const response = await axios.patch<Faq>(`${SERVER_URL}/faq/${id}`, data, apiHeader(tokenAdmin))
    return response.data
}

export const apiDeleteFaq = async (id: string): Promise<void> => {
    const tokenAdmin = localStorage.getItem('tokenAdmin')
    if (!tokenAdmin) throw new Error('Non autorisé')
    await axios.delete(`${SERVER_URL}/faq/${id}`, apiHeader(tokenAdmin))
}

export const apiGetFaqCategories = async (): Promise<string[]> => {
    const response = await axios.get<string[]>(`${SERVER_URL}/faq/categories`)
    return response.data
}

// Alias pour la compatibilité avec le code existant
export const faqApi = {
    getAll: apiGetFaqs,
    getById: apiGetFaq,
    getCategories: apiGetFaqCategories,
    create: apiCreateFaq,
    update: apiUpdateFaq,
    delete: apiDeleteFaq,
}
